import UUID from "../Utils/UUID";

export const Session = {
    _KEY: 'analytics_session_id',
    _storage: null,
    getId: ( options = { scope: 'tab' } ) => {
        Session._storage = options.scope === 'app' ? localStorage : sessionStorage;

        const currentId = Session._retrieveCurrentId();
        if( currentId ) return currentId;

        return Session._createNewId();
    },
    _retrieveCurrentId: () => {
        try {
            return Session._storage.getItem( Session._KEY );
        } catch ( error ) {
            console.error( 'error' , error );
        }
        return null;
    },
    _createNewId: () => {
        const id = new UUID().generate();
        try {
            Session._storage.setItem( Session._KEY , id );
        } catch ( error ) {
            console.error( 'error' , error );
        }
        return id;
    },
    _clear: () => {
        try {
            return Session._storage.removeItem( Session._KEY );
        } catch ( error ) {
            console.error( 'error' , error );
        }
    }
};
